// Pill-style tab switcher for the dancer view. Active tab uses the room's
// distinguishing color (pink for main, purple for late) so dancers can tell
// at a glance which room they're looking at.

const ROOM_TAB_COLORS = {
  main: 'bg-peak-accent text-white shadow',
  late: 'bg-peak-accent2 text-white shadow',
}

export default function RoomTabs({ current, onChange }) {
  const tabs = [
    { id: 'main', label: 'Main Room' },
    { id: 'late', label: 'Room 2' },
  ]
  return (
    <div className="flex bg-peak-surface rounded-xl p-1 text-sm font-medium">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`flex-1 py-2 rounded-lg transition-colors ${
            current === tab.id
              ? ROOM_TAB_COLORS[tab.id]
              : 'text-peak-muted hover:text-white'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
